import { IArticleBuilder } from "@sky-it-livedata/livedata-sports-design-system";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { isValidLmpPreviewArticleQuery } from "./typeguards";
import { CreateLmpPreviewTextInputSchema } from "appsync";
import { LmpPreviewArticleQuery } from "../types";
import { transformArticleElements } from "./article-transformer";
import { articleTemplatePreview } from "../templates/article-templates";

const transformer = (obj: LmpPreviewArticleQuery): IArticleBuilder => {

  if (isValidLmpPreviewArticleQuery(obj)) {
    CreateLmpPreviewTextInputSchema().parse(obj.data?.getLmpPreviewText);

    const payload: IArticleBuilder = {
      template: articleTemplatePreview,
      elements: transformArticleElements(obj) as unknown as IArticleBuilder['elements'],
    }

    return payload;
  } else {
    throw new WidgetError<ErrorName>({
      name: "NO_VALID_DATA",
      message: "Invalid transformer input, Error in LmpPreviewArticleQuery object",
      data: obj,
    });
  }
};

export default transformer;
